export default "__VITE_ASSET__5FrgqhJF__"